import { createContext, useContext, useEffect, useState } from 'react';

const FontSizeContext = createContext({ size: 'md', setSize: () => {} });

const SIZE_SCALES = { sm: '15px', md: '16px', lg: '18px', xl: '20px' };

export function FontSizeProvider({ children }) {
  const [size, setSize] = useState(() => {
    if (typeof window === 'undefined') return 'md';
    return localStorage.getItem('tikkun_font_size') || 'md';
  });
  useEffect(() => {
    document.documentElement.style.fontSize = SIZE_SCALES[size] || SIZE_SCALES.md;
    localStorage.setItem('tikkun_font_size', size);
  }, [size]);
  return <FontSizeContext.Provider value={{ size, setSize }}>{children}</FontSizeContext.Provider>;
}

export const useFontSize = () => useContext(FontSizeContext);
